import * as React from 'react';
import MoreVert from '@material-ui/icons/MoreVert';
import { usePopover } from '@deltasierra/react-hooks';
import { DSPopper } from '../mui/Popper';
import { DSGrow } from '../mui/transitions/Grow';
import { DSClickAwayListener } from '../mui/ClickAwayListener';
import { DSPaper } from '../mui/Paper';
import { DSMenuList } from '../mui/MenuList';
import { DSIconButton } from '../Generic/Buttons/DSIconButton';
import { HandleCloseContext } from './handle-close.context';
import { ActionMenuItem } from './ActionMenuItem';

export interface ActionMenuProps {
    'aria-label': string;
    children?: React.ReactNode;
}
export function ActionMenu(props: ActionMenuProps): JSX.Element {
    const [element, isOpen, { handleClose, handleListKeyDown, handleToggle }] = usePopover();

    return (
        <HandleCloseContext.Provider value={handleClose}>
            <DSIconButton
                aria-controls={isOpen ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                aria-label={props['aria-label']}
                color="primary"
                data-cy="action-button"
                size="small"
                onClick={handleToggle}
            >
                <MoreVert color="primary" />
            </DSIconButton>
            <DSPopper anchorEl={element} disablePortal open={isOpen} role={undefined} style={{ zIndex: 1 }} transition>
                {({ placement, TransitionProps }) => (
                    <DSGrow
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                    >
                        <DSPaper>
                            <DSClickAwayListener onClickAway={handleClose}>
                                <DSMenuList autoFocusItem={isOpen} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                    {props.children}
                                </DSMenuList>
                            </DSClickAwayListener>
                        </DSPaper>
                    </DSGrow>
                )}
            </DSPopper>
        </HandleCloseContext.Provider>
    );
}
ActionMenu.displayName = 'ActionMenu';
ActionMenu.Item = ActionMenuItem;
